import { Divider, List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {},
  divider: {
    backgroundColor: '#FF9800'
  },
}));


function WelcomeMessage({ messages = []  }) {

  const classes = useStyles();

  return (
    <List className={classes.root} >
      {Array.isArray(messages) && messages.map((m, index) => (
        <div key={index}>
          <ListItem alignItems="flex-start">
            <ListItemText primary={m} />
          </ListItem>
          <Divider className={classes.divider} />
        </div>
      ))}
    </List>
  );
}

export default WelcomeMessage;
